import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { api, ApiError } from "@/lib/api"
import type { Me } from "@/types/api"

export function useMe() {
  return useQuery<Me | null>({
    queryKey: ["me"],
    queryFn: async () => {
      try {
        return await api.get<Me>("/me")
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null
        throw e
      }
    },
    staleTime: 60_000,
    retry: false,
  })
}

export function useLogin() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) =>
      api.post<{ user: Me }>("/auth/login", { email, password }),
    onSuccess: (data) => {
      qc.setQueryData(["me"], data.user)
    },
  })
}

export function useSSOLogin() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => api.post<{ user: Me }>("/auth/sso"),
    onSuccess: (data) => {
      qc.setQueryData(["me"], data.user)
    },
  })
}

export function useLogout() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => api.post<{ status: string }>("/auth/logout"),
    onSuccess: () => {
      qc.setQueryData(["me"], null)
      qc.invalidateQueries()
    },
  })
}
